var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-form__options" },
    [
      _vm.productHasColors
        ? _c(
            "div",
            { staticClass: "product-form__options-item product-form__colors" },
            [
              _c(
                "p",
                { staticClass: "h6", attrs: { id: "product-form-color" } },
                [
                  _vm._v("\n      Color: "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.getColorString(_vm.product.swatch.color_name))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass:
                    "product-form__options-list product-form__options-list--color mb-0"
                },
                _vm._l(_vm.product.color_variants, function(color) {
                  return _c(
                    "li",
                    { key: color.id, staticClass: "product-form__color-item" },
                    [
                      _c(
                        "a",
                        {
                          class:
                            color.swatch.color_name ===
                            _vm.product.swatch.color_name
                              ? "active"
                              : "",
                          attrs: {
                            href: color.url,
                            "aria-label": _vm.getColorString(
                              color.swatch.color_name
                            ),
                            "aria-labelledby": "product-form-color"
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: color.swatch.url,
                              alt: _vm.getColorString(color.swatch.color_name)
                            }
                          })
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.productOptions, function(option, optionIndex) {
        return _c(
          "div",
          { key: optionIndex, staticClass: "product-form__options-item" },
          [
            _c(
              "div",
              { staticClass: "product-form__options-item-heading" },
              [
                _c("p", { staticClass: "h6" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(option.name) +
                      ": " +
                      _vm._s(_vm.selectedOptions["option_" + option.position]) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _vm.showSizeGuideLink(option.name)
                  ? _vm._t("sizeChart")
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm.isChipOption(option.name)
              ? _c(
                  "ul",
                  { staticClass: "product-form__options-list mb-0" },
                  _vm._l(option.values, function(value, valueIndex) {
                    return _c(
                      "li",
                      {
                        key: valueIndex,
                        staticClass: "product-form__chip-item"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "product-form__chip-option position-relative",
                            class: _vm.getOptionClasses(
                              "option_" + option.position,
                              value
                            )
                          },
                          [
                            _c(
                              "label",
                              { staticClass: "m-0", attrs: { for: value } },
                              [_vm._v(_vm._s(value))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.selectedOptions[
                                      "option_" + option.position
                                    ],
                                  expression:
                                    "selectedOptions[`option_${option.position}`]"
                                }
                              ],
                              attrs: {
                                id: value,
                                type: "radio",
                                name: "options[" + option.name + "]"
                              },
                              domProps: {
                                value: value,
                                checked: _vm._q(
                                  _vm.selectedOptions[
                                    "option_" + option.position
                                  ],
                                  value
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.selectedOptions,
                                    "option_" + option.position,
                                    value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              : _c(
                  "div",
                  { staticClass: "product-form__options-list" },
                  [
                    _c("SelectInput", {
                      attrs: { options: option.values },
                      on: {
                        input: function($event) {
                          return _vm.onSelectChange(
                            option.name,
                            "option_" + option.position
                          )
                        }
                      },
                      model: {
                        value: _vm.selectedOptions["option_" + option.position],
                        callback: function($$v) {
                          _vm.$set(
                            _vm.selectedOptions,
                            "option_" + option.position,
                            $$v
                          )
                        },
                        expression:
                          "selectedOptions[`option_${option.position}`]"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        ref: "select-" + option.name,
                        refInFor: true,
                        staticClass: "d-none",
                        attrs: { name: "options[" + option.name + "]" }
                      },
                      _vm._l(option.values, function(value, valueIndex) {
                        return _c(
                          "option",
                          { key: valueIndex, domProps: { value: value } },
                          [
                            _vm._v(
                              "\n          " + _vm._s(value) + "\n        "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }